export default function declarationToGeometry(declaration) {
	// eslint-disable-next-line no-eq-null
	return declaration && declaration.geometry && declaration.geometry.value != null ? declaration.geometry.value : null;
}
